module.exports = __webpack_public_path__ + "static/media/login-back-user-tablet.40fadc91.jpg";